/**
 * @module experience/store-operations
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const STORE_OPS_CONSTANTS = {
  STORE_OPS_AEM: 'pos',
  STORE_POS_TILL_CONFIRMATION_AEM: 'till-opening',
  POS_TILL_AMOUNT: 150.0,
  OPEN_POS_TILL_AMOUNT: '150',
  SELECT_NO_SALE_REASON: 'Select reason',
  DOLLAR_AMOUNT_SVF_FIELD_TYPE: 'dollar-amount',
  DOLLAR_AMOUNT: '$ 0.00',
  MAX_OUT_OF_BALANCE: 3,
  MOBILITY_TILL_OUT_OF_BALANCE: 'Mobility till is out of balance',
  MOBILITY_TILL_IN_BALANCE: 'Mobility till is in balance',
  MOBILITY_TILL_IN_CONFIRMATION: 'Open mobility till confirmation',
  Open: 'Open',
  Closed: 'Closed',
  closingPosTill: 'Closing POS till',
  CLOSE_POS_TILL_CONFIRMATION: '/store-ops/close-pos-till-confirmation',
  STORE_OPS: '/store-ops',
  CLOSE_MOBILITY_TILL_CONFIRMATION_STATE: '/store-ops/close-mobility-till-confirmation',
  TRANSACTION_ID: 'transactionId',
  ONE: 1,
  FIXED_TWO_DECIMAL: 2,
  CASH: 'cash',
  PRINT_ID: 'mobileTill',
  POS_TILL_PRINT_ID: 'posTill',
  IN_BALANCE: 'POS till is in balance',
  OUT_OF_BALANCE: 'POS till is out of balance',
  CONTINUE: 'save&Continue',
  STORE_OPERATIONS_MODULE: 'StoreOperationsModule',
  TILL_TYPE_POS: 'POS',
  TILL_TYPE_MOBLE: 'MOBILE',
  ROUND_CONST: 100,
};

export const STORE_STATES = {
  DEFAULT_STORE_STATE: '/store-ops',
  OPEN_STORE_STATE: '/store-ops/open-store',
  CLOSE_STORE_STATE: '/store-ops/close-store',
  NO_SALE_STATE: '/store-ops/no-sale',
  OPEN_POS_TILL_STATE: '/store-ops/open-pos',
  OPEN_POS_TILL_CONFIRMATION_STATE: '/store-ops/store-ops-pos-till-confirmation',
  OPEN_MOBILITY_TILL_STATE: '/store-ops/open-mobility-till',
  OPEN_MOBILITY_TILL_CONFIRMATION_STATE: '/store-ops/open-mobility-till-confirmation',
  CLOSE_POS_TILL_STATE: '/store-ops/close-pos-till',
  CHANGE_STORE_LOCATION: '/store-ops/change-store-location',
  PRINTS_REPORTS_STATE: '/store-ops/print-landing-reports',
  DAILY_REPORTS_STATE: '/store-ops/daily-reports',
  MANAGEMENT_REPORTS_STATE: '/store-ops/management-reports',
  ONDEMAND_REPORTS_STATE: '/store-ops/onDemand-reports',
  CHANGESTORE_ADDRESS_STATE: '/store-ops/change-store-address',
};

export const PRINT_REPORTS_CONSTANTS = {
  DAILY_REPORTS: 'dailyReports',
  MANAGEMENT_REPORTS: 'managementReports',
  DAILY_REGISTER_SUMMARY_LISTING_TILL_REPORT: 'DailyRegisterSummaryListingTillReport',
  ON_DEMAND_REPORTS: 'onDemandReports',
  DAILY_REPORTS_HEADING: 'Daily reports',
  MANAGEMENT_REPORTS_HEADING: 'Management reports',
  ON_DEMAND_REPORTS_HEADING: 'On demand reports',
  REPORTS_MIN_DATE: 89,
  TIMESTAMP: 'T00:00:00',
  REPORTDATEFORMAT: 'YYYY-MM-DD',
  REPORTDATECHANGEFORMAT: 'yyyy-MM-dd',
  PRINTABLE: 'printable',
  IFRAME: 'iframe',
  PROPERTY: '0',
  COMPLETE: 'complete',
  NONE: 'none',
  NOSALE_REPORT: 'NoSaleReport',
  DAILY_REGISTER_CASH_SUMMARY_REPORT: 'DAILYREGISTERCASHSUMMARYREPORT',
  INTERVAL: 1500,
};

export const DAILY_REPORTS = {
  DAILY_PAYMENT_PRINTABLE: 'dailyPaymentprintable',
  DAILY_HANDSET_CHECKBOX_PRINTABLE: 'dailyHandsetCheckboxprintable',
  SYSTEMATIC_POST_VOID: 'systematicPostVoid',
};

export const REPORTS = {
  dailyReports: {
    dailyPayment: { selected: false },
    postCheckbox: { selected: false },
    overrideReport: { selected: false },
    reprintCheckbox: { selected: false },
    returnCheckbox: { selected: false },
    summaryCheckbox: { selected: false },
    dailyHandsetCheckbox: { selected: false },
    systematicPostVoid: { selected: false },
  },
  closeReports: {
    postCheckbox: 'postCheckbox',
    returnCheckbox: 'returnCheckbox',
    dailyHandsetCheckbox: 'dailyHandsetCheckbox',
    summaryCheckbox: 'summaryCheckbox',
    overrideReport: 'overrideReport',
    dailyPayment: 'dailyPayment',
    systematicPostVoid: 'systematicPostVoid',
  },
  dailyTransactionAudit: {
    TRANSACTION_AUDIT_REPORT: 'DailyTransactionAuditReport',
  },
  dailyInventoryReport: {
    DAILY_INVENTORY_REPORT: 'DailyInventoryReport',
  },
  managementReports: {
    closingCheckbox: { selected: false },
    dailyReportCheckbox: { selected: false },
    depoistCheckbox: { selected: false },
    dailyRegistercheckbox: { selected: false },
  },
  onDemandReports: {
    auditDemand: { selected: false },
    inventoryDemand: { selected: false },
    reconciliationDemand: { selected: false },
  },
  CLOSING_CHECKBOX: 'closingCheckbox',
  DAILY_PAYMENT_CHECKBOX: 'dailyPayment',
  DAILY_CASH: 'dailyCash',
  SYSTEMATIC_POST_VOID_CHECKBOX: 'systematicPostVoid',
  SUMMARY_CHECKBOX: 'summaryCheckbox',
  DAILY_REPORT_CHECKBOX: 'dailyReportCheckbox',
  DAILY_HANDSET_REPORT: 'dailyHandsetCheckbox',
  DEPOSIT_CHECKBOX: 'depoistCheckbox',
  DAILY_REGISTER_CHECKBOX: 'dailyRegistercheckbox',
  INVENTORY_DEMAND: 'inventoryDemand',
  POST_CHECKBOX: 'postCheckbox',
  OVERRIDE_REPORT: 'overrideReport',
  REPRINT_CHECKBOX: 'reprintCheckbox',
  RETURN_CHECKBOX: 'returnCheckbox',
  AUDIT_DEMAND: 'auditDemand',
  RECONCILIATION_DEMAND: 'reconciliationDemand',
  CC_LAST_4: 'ccLastFour',
  AUTH_CODE: 'authCode',
  RECORD: 'recordNumber',
  MANUAL: 'manual',
  SIGNATURE: 'signature',
  INTL_PYMT: 'intlPymt',
  EIP_AMT: 'eipAmt',
  TERMS: 'terms',
  CC: 'cc',
  DEBIT: 'Debit',
  INSTALLMENT_PAY: 'Installment Pay',
  LEASE_PMNT_TTL: 'Lease Pmnt Ttl',
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  DISCOVER: 'Discover',
  AMERICAN_EXPRESS: 'American Express',
  DAILY_PAYMENT_REPORTS: 'DailyPaymentReportComponent',
  ONDEMAND_REPORTS: 'OnDemandReportsCommonComponent',
  CASE_TENDER_CODE: '1',
  VISA_TENDER_CODE: '3',
  DEBIT_TENDER_CODE: '16',
  INSTALMENT_TENDER_CODE: '15',
  DEVICE_TENDER_CODE: '6',
  LEASE_TENDER_CODE: '19',
  MASTER_TENDER_CODE: '4',
  AMEX_TENDER_CODE: '5',
  DAILYPAYMENTLISTINGREPORT: 'DAILYPAYMENTLISTINGREPORT',
  DAILYHANDSETCONTRACTREPORT: 'DAILYHANDSETCONTRACTREPORT',
  CHECKED: 'checked',
  SYSTEMATICPOSTVOIDREPORT: 'systematicPostVoidReport',
  RETURNS_REPORT: 'ReturnsReport',
  POST_VOID_REPORT: 'PostVoidReport',
  SLEEP_INTERVAL: 3000,
  DEBIT_CREDIT_RECONCILIATION_REPORT: 'DebitCreditCardReconciliationReport',
  DAILY_REG_SUMMARY_LISTING_TILL_REPORT_REPRINT: 'DailyRegisterSummaryListingTillReportReprint',
  DEPOSIT_REPORT: 'DepositReport',
  CLOSING_DETAILS_REPORT: 'ClosingDetailsReport',
};

export const SET_STORE_ADDRESS_CONSTANTS = {
  REQUIRED_TRUE: true,
  ADDRESS_CONTINUE_BUTTON: 'Continue',
  ADDRESS_CANCEL_BUTTON: 'Cancel',
  BUTTON_SECONDARY_CLASS: 'btn btn-secondary',
  BUTTON_PRIMARY_CLASS: 'btn btn-primary',
  BUTTON_TYPE_SECONDARY: 'secondary',
  BUTTON_TYPE_PRIMARY: 'primary',
  API_200_OK: '200',
  ACTIVE: 'Active',
  SET_ADDRESS_FORM_VIEW: 'setAddressFormView',
  SET_ADDRESS_SUGGESTED_FORM_VIEW: 'suggestedAddressView',
  SET_ADDRESS_CONFIRM_FORM_VIEW: 'confirmAddresView',
  GEO_CODE_CONSTANT: 'GeoTAXKeyO',
  OPEN_STORE_TITLE: 'Open Store',
  CHANGE_STORE_ADDRESS: 'Change Store Address',
  STORE_STATUS_OPEN: 'open',
  STORE_STATUS_CLOSE: 'closed',
};
